import { ScanBarcode } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";

type TrackingFormFields = {
  trackingUrl?: string;
  trackingCode?: string;
};

export const TrackingInfo = () => {
  const { t } = useTranslation("boExpeditionForm");
  const methods = useFormContext<TrackingFormFields>();

  return (
    <AccordionItem
      value="trackingInfo"
      className="shadow-basic flex w-full max-w-[1400px] flex-col items-start justify-center gap-4 rounded-xl border border-gray-200 bg-slate-100 p-6"
    >
      <AccordionTrigger className="flex w-full flex-row items-start justify-between gap-2 self-start !no-underline">
        <div className="flex flex-row items-center gap-2 self-start">
          <ScanBarcode className="h-6 w-6 !rotate-0 text-blue-600" />
          <p className="text-xl font-bold">{t("trackingInfo.title")}</p>
        </div>
      </AccordionTrigger>
      <AccordionContent forceMount className="flex w-full flex-col gap-2">
        <div className="flex w-full flex-col gap-2 @xl:flex-row">
          <ControlledUnifiedInput
            control={methods.control}
            name="trackingUrl"
            label={t("trackingInfo.trackingUrlLabel")}
            placeholder={t("trackingInfo.trackingUrlPlaceholder")}
            className="w-full"
            wrapperClassName="w-full"
          />
          <ControlledUnifiedInput
            control={methods.control}
            name="trackingCode"
            label={t("trackingInfo.trackingCodeLabel")}
            placeholder={t("trackingInfo.trackingCodePlaceholder")}
            className="w-full"
            wrapperClassName="w-full"
          />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
